import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { Grid, Typography, Box } from "@mui/material";
import { Button } from "abs-ui-components";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { API_ROUTES } from "../../ApiRoutes/ApiRoutes";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import RichTextEditor from "../../RichTextEditor/RichTextEditor";

const AdditionalAndRevisedMeasures = ({ additionalmeasures, refetchMonitoringData,vesselMstId }) => {
   
    const editorRef = useRef(null);
    const [editorContent, setEditorContent] = useState("");
    const [lastSavedContent, setLastSavedContent] = useState(""); 
	const [isSavingDescription, setIsSavingDescription] = useState(false);
    const [error, setError] = useState("");

   
    useEffect(() => {
        if (additionalmeasures) {
            setEditorContent(additionalmeasures);
            setLastSavedContent(additionalmeasures);
        }
    }, [additionalmeasures]);

    const handleSave = async () => {
        if (!editorRef.current) return;

        const editorHTML = editorRef.current.getHTML();
        

        try {
            setIsSavingDescription(true);
            const res = await callApi({
                method: "POST",
                url: API_ROUTES.AdditionalAndRevisedMeasures(vesselMstId),
                data: JSON.stringify(editorHTML),
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (res?.isSuccess) {
                emitToasterMsg("success", "Additional and Revised Measures", "Saved successfully");
                await refetchMonitoringData?.();
                setError("");
                setEditorContent(editorHTML);
            } else {
                emitToasterMsg("error", "Additional and Revised Measures", res?.errorMessage);
            }
        } catch (err) {
            emitToasterMsg("error", "Additional and Revised Measures", err.message);
        }  finally {
			setIsSavingDescription(false);
		}
    };
    const isSaveDisabled = isSavingDescription || !editorContent.trim() || editorContent === lastSavedContent;

    return (
        <Box mt={3}>
            <Grid container spacing={2} alignItems="flex-start">
                <Grid item xs={12} md={2}>
                    <Typography variant="body2" fontWeight={600}>
                        Description
                    </Typography>
                </Grid>

                <Grid item xs={12} md={9}>
                    <Box
                        border="1px solid #ccc"
                        borderRadius={1}
                        p={1}
                        sx={{  background: "#fff" }}
                    >
                        <RichTextEditor
                            ref={editorRef}
                            value={editorContent}
                            onChange={setEditorContent} 
                            placeholder="Enter the description for additional and revised Measures..."
                        />
                    </Box>

                    {error && (
                        <Typography variant="caption" color="error" mt={1}>
                            {error}
                        </Typography>
                    )}

                    <Box mt={2} mb={2}>
                        <Button onClick={handleSave} disabled={isSaveDisabled} size="small">
                            Save
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default AdditionalAndRevisedMeasures;
